import {
  alertCircleOutline,
  warningOutline,
  checkmarkCircleOutline,
  closeOutline,
  informationCircleOutline,
} from 'ionicons/icons'
import type { ToastButton } from '@ionic/react'
import { ToastColor } from './store/toast.constants'

const iconByColor: Record<ToastColor, string> = {
  [ToastColor.Error]: alertCircleOutline,
  [ToastColor.Warning]: warningOutline,
  [ToastColor.Success]: checkmarkCircleOutline,
  [ToastColor.Info]: informationCircleOutline,
}

const getIconByToastColor = (color?: ToastColor): string | undefined => {
  if (!color) return undefined
  return iconByColor[color]
}

const toastCancelButton: ToastButton[] = [{ icon: closeOutline, role: 'cancel' }]

export const getToastProps = (color?: ToastColor) => ({
  color,
  icon: getIconByToastColor(color),
  buttons: toastCancelButton,
})
